import type { LimitOrderReferentialFormResponse } from 'apiConnector/secondary-market/limit-order/models';
import type { SecondaryMarketLimitOrderKycActions } from 'state/secondaryMarket/limit-order/kyc/kyc.actions';
import type { SecondaryMarketLimitOrderOrderActions } from 'state/secondaryMarket/limit-order/order/order.action';
import { secondaryMarketActionsFactory } from 'state/secondaryMarket/shared/actions';

import type { SecondaryMarketLimitOrderAmendActions } from './amend/amend.actions';
import type { SecondaryMarketLimitOrderCancellationsActions } from './cancellation/cancellations.actions';
import type { SecondaryMarketLimitOrderFormActions } from './form/form.actions';

export const limitOrderActions = secondaryMarketActionsFactory<LimitOrderReferentialFormResponse, 'LIMIT_ORDER'>(
  'LIMIT_ORDER',
);
type TypeOfLimitOrderActions = typeof limitOrderActions;

export type SecondaryMarketLimitOrderActions =
  | SecondaryMarketLimitOrderInitFormFetchRequested
  | SecondaryMarketLimitOrderInitFormFetched
  | SecondaryMarketLimitOrderInitFormFetchedFailed
  | SecondaryMarketLimitOrderReloadRequestedByOrderId
  | SecondaryMarketLimitOrderFormActions
  | SecondaryMarketLimitOrderOrderActions
  | SecondaryMarketLimitOrderCancellationsActions
  | SecondaryMarketLimitOrderAmendActions
  | SecondaryMarketLimitOrderKycActions;

export type SecondaryMarketLimitOrderInitFormFetchRequested = ReturnType<
  TypeOfLimitOrderActions['initFormFetchRequested']
>;
export type SecondaryMarketLimitOrderInitFormFetched = ReturnType<TypeOfLimitOrderActions['initFormFetched']>;
export type SecondaryMarketLimitOrderInitFormFetchedFailed = ReturnType<
  TypeOfLimitOrderActions['initFormFetchedFailed']
>;

export type SecondaryMarketLimitOrderReloadRequestedByOrderId = ReturnType<
  TypeOfLimitOrderActions['secondaryMarketReloadRequestedByOrderId']
>;
